<style scoped>
/* --- CSS original --- */
.contenedormargin {
    padding-left: 5%;
    padding-right: 5%;
    margin-bottom: 2%;
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.modal-image {
    width: 100%;
    height: auto;
    transition: transform 0.3s ease-in-out;
    /* Animación suave para el zoom */
}

.custom-icon {
    font-size: 3rem;
    color: #ff9900;
}

.parallax-section {
    position: relative;
    background-color: #3498db;
    /* Fondo simple */
    height: 500px;
    transition: transform 0.3s ease-out;
}

.parallax-section.scrolled {
    transform: translateY(-20px);
    /* Efecto de desplazamiento */
}

.sticky-col {
    position: sticky;
    top: 80px;
    /* Ajusta según tu header o espacio superior */
    height: calc(100vh - 80px);
    /* Para que tome altura completa menos lo que queda arriba */
    overflow-y: auto;
    /* Para scroll interno si el contenido es muy largo */
}

.img-uniforme {
    width: 300px;
    /* ancho fijo deseado */
    height: 200px;
    /* alto fijo deseado */
    object-fit: cover;
    /* recorta y escala para llenar sin distorsión */
    display: block;
}

.boton-con-sombra {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: box-shadow 0.3s ease;
}

.boton-con-sombra:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

ul::-webkit-scrollbar {
    height: 0px;
}

.card:hover {
    transform: scale(1.03);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.favoritos-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.img-thumbnail:hover img {
    opacity: 0.3;
    /* La miniatura se desvanece */
}

.img-thumbnail:hover .position-absolute {
    opacity: 1;
    /* El overlay se muestra */
}

.linea-descripcion {
    display: flex;
    gap: 10px;
}

.linea,
.descripcion {
    padding: 5px;
}

.linea-descripcion {
    display: flex;
    gap: 10px;
    flex-wrap: nowrap;
    /* evita que la descripción caiga abajo */
    align-items: stretch;
    /* fuerza que ambos ocupen la misma altura */
}

.linea {
    flex: 0 0 auto;
    /* ancho mínimo, no crece ni se reduce */
    min-width: 120px;
    /* mínimo para línea */
    font-weight: bold;
    display: flex;
    align-items: center;
    /* centra verticalmente */
}

.descripcion {
    flex: 1 1 auto;
    /* ocupa todo el espacio restante */
    white-space: normal;
    /* permite wrap del texto */
}

/* --- Galería de imágenes (Modal) --- */
::v-deep(.modal-galeria) {
    max-width: 90%;
    width: 100%;
    padding: 0;
}

::v-deep(.modal-galeria-img) {
    max-height: 500px;
    width: 100%;
    object-fit: contain;
}

::v-deep(.modal-galeria-thumbs) {
    display: flex;
    overflow-x: auto;
    gap: 0.5rem;
    padding: 0.5rem;
    white-space: nowrap;
}

::v-deep(.modal-galeria-thumbs li) {
    flex: 0 0 auto;
    width: 80px;
    height: 80px;
    cursor: pointer;
    border-radius: 0.25rem;
    overflow: hidden;
    border: 2px solid transparent;
    transition: border-color 0.2s;
}

::v-deep(.modal-galeria-thumbs li.selected) {
    border-color: #ff9900;
}

::v-deep(.modal-galeria-thumbs li img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* --- Responsivo --- */
@media (max-width: 768px) {
    .contenedor {
        margin-top: 15%;
    }

    ::v-deep(.modal-galeria-img) {
        max-height: 300px;
    }

    ::v-deep(.modal-galeria-thumbs li) {
        width: 60px;
        height: 60px;
    }
}
</style>
<template>
    <div v-if="loading" class="container pagos-recientes-container py-4">
        <div class="row g-3">

            <!-- Columna izquierda: menú lateral + miniaturas -->
            <div class="col-12 col-md-2 d-none d-md-flex flex-column gap-2">
                <!-- Botones de menú -->
                <div v-for="n in 3" :key="'skeleton-menu-' + n" class="placeholder-glow mb-2">
                    <span class="placeholder col-12 rounded" style="height: 40px; display: block;"></span>
                </div>

                <!-- Miniaturas -->
                <div class="mt-3 placeholder-glow" v-for="n in 6" :key="'skeleton-thumb-' + n">
                    <span class="placeholder col-12 rounded" style="height: 100px; display: block;"></span>
                </div>
            </div>

            <!-- Columna central: imagen principal -->
            <div class="col-12 col-md-6 d-flex justify-content-center">
                <div class="placeholder-glow w-100" style="height: 400px; max-width: 600px;">
                    <span class="placeholder col-12 h-100 rounded"></span>
                </div>
            </div>

            <!-- Columna derecha: detalle producto -->
            <div class="col-12 col-md-4 d-flex flex-column gap-2">
                <!-- Clave / título -->
                <div class="placeholder-glow">
                    <span class="placeholder col-6 rounded" style="height: 30px; display: block;"></span>
                </div>
                <!-- Línea y descripción -->
                <div v-for="n in 5" :key="'skeleton-detail-' + n" class="placeholder-glow">
                    <span class="placeholder col-12 rounded" style="height: 20px; display: block;"></span>
                </div>
                <!-- Botones o badges -->
                <div class="placeholder-glow d-flex gap-2 mt-2" v-for="n in 3" :key="'skeleton-badges-' + n">
                    <span class="placeholder col-4 rounded" style="height: 30px; display: inline-block;"></span>
                </div>
            </div>
        </div>

        <!-- Bloque de aplicaciones -->
        <div class="mt-4">
            <h5 class="placeholder-glow">
                <span class="placeholder col-3 rounded"></span>
            </h5>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="n in 8" :key="'skeleton-apk-th-' + n" class="placeholder-glow">
                                <span class="placeholder col-12 rounded"></span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="n in 3" :key="'skeleton-apk-tr-' + n">
                            <td v-for="m in 8" :key="'skeleton-apk-td-' + n + '-' + m" class="placeholder-glow">
                                <span class="placeholder col-12 rounded" style="height: 20px; display: block;"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Bloque de conversiones/OEMs -->
        <div class="row g-3 mt-4">
            <div class="col-12 col-md-6" v-for="n in 2" :key="'skeleton-conversion-' + n">
                <h6 class="placeholder-glow mb-2">
                    <span class="placeholder col-4 rounded"></span>
                </h6>
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                            <tr v-for="m in 3" :key="'skeleton-conv-tr-' + n + '-' + m">
                                <td class="placeholder-glow">
                                    <span class="placeholder col-12 rounded"
                                        style="height: 20px; display: block;"></span>
                                </td>
                                <td class="placeholder-glow">
                                    <span class="placeholder col-12 rounded"
                                        style="height: 20px; display: block;"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Productos relacionados -->
        <div class="mt-4">
            <h5 class="placeholder-glow mb-3">
                <span class="placeholder col-3 rounded"></span>
            </h5>
            <div class="row g-3">
                <div class="col-6 col-md-3" v-for="n in 4" :key="'skeleton-rel-' + n">
                    <div class="placeholder-glow">
                        <span class="placeholder col-12 rounded" style="height: 120px; display: block;"></span>
                        <span class="placeholder col-12 rounded mt-2" style="height: 20px; display: block;"></span>
                        <span class="placeholder col-8 rounded mt-1" style="height: 15px; display: block;"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div v-else class="content contenedormargin pagos-recientes-container">

        <div v-if="estadoproducto === 0" class="status-message not-found">
            <i :class="$t('icons.error')"></i>
            <p>{{ $t('status.notFound') }}</p>
        </div>
        <div v-else-if="estadoproducto === 2" class="status-message unavailable">
            <i :class="$t('icons.block')"></i>
            <p>{{ $t('status.unavailable') }}</p>
        </div>
        <div v-else>
            <div class="row" style="height: auto;">
                <!-- Primera columna -->
                <!-- Menú lateral -->
                <div class="col-12 col-md-2 order-2 order-md-1 d-none d-md-flex align-items-start flex-column text-black text-center p-3"
                    style="max-height: 100vh; overflow-y: auto;">
                    <!-- Botones -->
                    <div class="mb-3 d-flex align-items-center gap-2" @click="scrollToAplicaciones('ventas')"
                        style="cursor: pointer;">
                        <i class="bx bx-bar-chart custom-icon fs-4"></i>
                        <span class="fw-semibold">Sugerencias</span>
                        <span class="text-muted">(—)</span>
                    </div>

                    <div class="mb-3 d-flex align-items-center gap-2" v-if="detailsprods.aplicaciones.length > 0"
                        @click="scrollToAplicaciones('aplicaciones')" style="cursor: pointer;">
                        <i class="bx bx-cog custom-icon fs-4"></i>
                        <span class="fw-semibold">Aplicaciones</span>
                        <span class="text-muted">({{ detailsprods.aplicaciones.length }})</span>
                    </div>

                    <div class="mb-3 d-flex align-items-center gap-2"
                        v-if="detailsprods.conversiones.length > 0 || detailsprods.oems.length > 0"
                        @click="scrollToAplicaciones('conversionesproductos')" style="cursor: pointer;">
                        <i class="bx bx-sort custom-icon fs-4"></i>
                        <span class="fw-semibold">Conversiones</span>
                        <span class="text-muted">({{ detailsprods.conversiones.length + detailsprods.oems.length
                        }})</span>
                    </div>

                    <!-- Miniaturas debajo -->
                    <div class="w-100 mt-4" style="overflow-y: auto; overflow-x: hidden;">
                        <div class="row row-cols-2 g-2 mx-0">
                            <!-- Miniatura especial 360° al final -->
                            <div class="col px-1" v-if="detailsprods.PicturesUrl.length > 20">
                                <div @click="view360(detailsprods.PicturesUrl)"
                                    class="position-relative d-flex align-items-center justify-content-center img-thumbnail w-100"
                                    style="height: 100px; cursor: zoom-in; background-color:#06283c; ">
                                    <span class="fw-bold text-center" style="color:#D97706;">
                                        360°<br>
                                    </span>
                                </div>
                            </div>
                            <!-- Miniaturas definidas -->
                            <template v-if="detailsprods.categorias[0].marcas.viewimages">
                                <div v-for="(imagen, index) in detailsprods.categorias[0].marcas.viewimages"
                                    :key="'img-definida-' + index" class="col px-1">
                                    <template v-if="detailsprods.PicturesUrl[imagen.imagen]">
                                        <img :src="detailsprods.PicturesUrl[imagen.imagen].sm" alt=""
                                            @click="imagenselec(imagen.imagen)" loading="lazy"
                                            class="img-thumbnail w-100"
                                            style="height: 100px; object-fit: cover; cursor: pointer;" />
                                    </template>
                                </div>
                            </template>

                            <!-- Miniaturas alternativas si no hay viewimages -->
                            <template v-else>
                                <div v-for="i in [1, 3, 5, 7]" :key="'img-alternativa-' + i" class="col px-1"
                                    v-if="detailsprods.PicturesUrl[i]">
                                    <img :src="detailsprods.PicturesUrl[i].sm" alt="" @click="imagenselec(i)"
                                        loading="lazy" class="img-thumbnail w-100"
                                        style="height: 100px; object-fit: cover; cursor: pointer;" />
                                </div>
                            </template>
                            <div v-if="detailsprods.categorias[0].marcas.viewimages &&
                                Object.entries(detailsprods.PicturesUrl).length > detailsprods.categorias[0].marcas.viewimages.length"
                                class="col px-1">

                                <div @click="verTodasLasImagenes()" class="position-relative img-thumbnail w-100"
                                    style="height: 100px; cursor: zoom-in; overflow: hidden;"
                                    v-tooltip.top="'Ver galería de imágenes'">

                                    <!-- Miniatura de fondo: toma la primera imagen disponible -->
                                    <template v-if="detailsprods.categorias[0].marcas.viewimages">
                                        <div v-for="(imagen, index) in detailsprods.categorias[0].marcas.viewimages"
                                            :key="'img-definida-' + index" class="col px-1">
                                            <!-- Mostrar la imagen si existe -->
                                            <img :src="detailsprods.PicturesUrl?.[imagen.imagen]?.sm || primeraImagen(detailsprods)"
                                                alt="miniatura" @click="imagenselec(imagen.imagen)" loading="lazy"
                                                class="img-thumbnail w-100"
                                                style="height: 100px; object-fit: cover; cursor: pointer;" />
                                        </div>
                                    </template>


                                    <!-- Overlay -->
                                    <div class="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                                        style="background: linear-gradient(135deg, #06283c80, #06283c40); color: white; font-weight: bold; font-size: 0.9rem; opacity: 0; transition: 0.3s ease;">
                                        {{ Object.entries(detailsprods.PicturesUrl).length -
                                            detailsprods.categorias[0].marcas.viewimages.length
                                        }}+<br>imágenes
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- Segunda columna (Imagen) -->
                <div class="col-12 col-md-6 order-1 order-md-2 d-flex align-items-center justify-content-center text-black text-center p-3"
                    style="height: 100%;">
                    <div class="d-flex flex-column w-100">
                        <!-- Contenedor fijo para imagen grande -->
                        <div class="image-container mx-auto"
                            style="height: 400px; width: 100%; max-width: 600px; overflow: hidden; position: relative;">

                            <img v-if="detailsprods.PicturesUrl[imagenposicion]"
                                :src="detailsprods.PicturesUrl[imagenposicion].sm" alt="Descripción"
                                class="img-fluid grande" loading="lazy"
                                @click="openModal(detailsprods.PicturesUrl[imagenposicion].sm)"
                                v-tooltip.bottom="'Haz clic para hacer zoom'" style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          cursor: zoom-in;
        " />
                            <img v-else alt="Descripción" :src="getAbsoluteImageUrl('/img/display/Placeholder.png')"
                                loading="lazy" class="img-fluid grande" style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          cursor: default;
        " />
                        </div>
                    </div>
                </div>
                <!-- Tercera columna -->
                <div class="col-12 col-md-4 order-3 d-flex flex-column text-black text-center p-3">
                    <!-- Clave producto centrada con espacio -->
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <!-- Lado izquierdo -->
                        <div class="d-flex align-items-center gap-2">
                            <AgregarAFavoritos :producto_id="detailsprods.id" :k_parte="detailsprods.k_parte"
                                v-if="isLoggedin" @actualizar-estado="actualizarEstadoListaFavoritos"
                                class="favoritos-btn" />
                            <h3 class="fw-bold card-title-kparte-details mb-0">
                                {{ detailsprods.k_parte }}
                            </h3>
                        </div>

                        <!-- Lado derecho (precio) -->
                        <div class="d-flex flex-wrap gap-2 justify-content-end" style="min-width: 180px;">
                            <Badges :item="detailsprods" wrapperClass="d-flex flex-wrap gap-2"
                                :fontSize="'13px'" />
                            <i :class="$t('icons.shareAlt')" style="cursor: pointer; font-size: 18px; margin-left: 8px;"
                                @click="shareContent"></i>
                        </div>
                    </div>

                    <div class="linea-descripcion">
                        <div class="linea">{{ detailsprods.linea }}</div>
                        <div class="descripcion">{{ detailsprods.descripcion }}</div>
                    </div>


                    <div class="mb-3" v-if="detailsprods.ShoppingCart">
                        <car :sucursales="detailsprods.ShoppingCart" :codigoParte="detailsprods.k_parte"
                            :precio="Number(detailsprods.precio_ajuste.valor)"
                            :preciobase="Number(detailsprods.precio_base.valor)" :codigoId="Number(detailsprods.id)" :permisoprecios="Number(detailsprods.permisoprecios)" :permisocompras="Number(detailsprods.permisocompras)" :permisoexistencias="Number(detailsprods.permisoexistencias)">
                        </car>
                    </div>
                    <div class="mb-3" v-else-if="!detailsprods.ShoppingCart && isLoggedin">basg
                        <i class="fa fa-exclamation-triangle" aria-hidden="true" style="color: #FFFF00;"></i>
                        <p style="font-size: 10px; margin-left: 5px;">
                            Disculpa tenemos algunos inconvenientes no podemos habilitar las opciones de comprador
                        </p>
                    </div>
                    <div class="mb-3" v-else>
                        <p style="font-size: 10px;">
                            Las opciones de compra solo aparecen para clientes.
                            <router-link :to="{ name: 'Ingresa' }"
                                style="font-size: 12px; text-decoration: none; color: inherit; cursor: pointer;">
                                <strong>Inicia Sesión</strong>
                            </router-link>
                        </p>
                    </div>

                    <div class="mb-1" v-if="detailsprods.variante">
                        <viewsProdsVariante :variante="detailsprods.variante" :original="detailsprods.k_parte">
                        </viewsProdsVariante>
                    </div>
                </div>
            </div>
            <!-- Bloque de Aplicaciones -->
            <div id="aplicaciones" class="w-100" style="margin-top: 0; padding-top: 1px; margin-bottom: 1%;"
                v-if="detailsprods.aplicaciones.length > 0"
                v-tooltip.top="`Sección para ver la compatibilidad con otros autos`">
                <h4>
                    <i class="bx bx-sort" style="font-size: 1.5rem; margin-right: 10px;"></i>
                    &nbsp;Aplicaciones del Producto
                </h4>
                <!-- Hacer la tabla responsiva -->
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th @click="sortBy('year')" style="cursor:pointer">
                                    Años
                                    <span v-if="sortKey === 'year'">{{ sortAsc ? '▲' : '▼' }}</span>
                                </th>
                                <th @click="sortBy('marca')" style="cursor:pointer">
                                    Marca
                                    <span v-if="sortKey === 'marca'">{{ sortAsc ? '▲' : '▼' }}</span>
                                </th>
                                <th @click="sortBy('modelo')" style="cursor:pointer">
                                    Modelo
                                    <span v-if="sortKey === 'modelo'">{{ sortAsc ? '▲' : '▼' }}</span>
                                </th>

                                <th @click="sortBy('motor')" style="cursor:pointer">
                                    Motor
                                    <span v-if="sortKey === 'motor'">{{ sortAsc ? '▲' : '▼' }}</span>
                                </th>
                                <!--
                                <th @click="sortBy('transmicion')" style="cursor:pointer">
                                    Transmisión
                                    <span v-if="sortKey === 'transmicion'">{{ sortAsc ? '▲' : '▼' }}</span>
                                </th>
                                <th @click="sortBy('combustible')" style="cursor:pointer">
                                    Combustible
                                    <span v-if="sortKey === 'combustible'">{{ sortAsc ? '▲' : '▼' }}</span>
                                </th>-->
                                <th @click="sortBy('posicion')" style="cursor:pointer">
                                    Posición
                                    <span v-if="sortKey === 'posicion'">{{ sortAsc ? '▲' : '▼' }}</span>
                                </th>
                                <th>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="apk in paginatedData" :key="apk.id">
                                <td><strong>{{ apk.year }}</strong></td>
                                <td>{{ apk.marca !== '-' ? apk.marca : 'TODAS LAS MARCAS' }}</td>
                                <td>{{ apk.modelo !== '-' ? apk.modelo : 'TODOS LOS MODELOS' }}</td>


                                <td>
                                    <div v-if="apk.motores && apk.motores.length">
                                        <div v-for="(m, index) in apk.motores" :key="index">
                                            {{ m.litros.endsWith('L') ? m.litros : m.litros + 'L' }} {{ m.cilindros }}
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{ (apk.litros !== '-' && apk.cilindros !== '-')
                                            ? (apk.litros.endsWith('L') ? apk.litros : apk.litros + 'L') + ' ' +
                                            apk.cilindros
                                            : 'TODOS LOS MOTORES' }}
                                    </div>
                                </td>
                                <!--<td>{{ apk.transmicion !== '-' ? apk.transmicion : 'TODAS LAS TRANSMISIONES' }}</td>
                                <td>{{ apk.combustible !== '-' ? apk.combustible : 'TODOS LOS COMBUSTIBLES' }}</td>-->
                                <td><strong>{{ apk.posicion !== '-' ? apk.posicion : 'TODAS LAS POSICIONES' }}</strong>
                                </td>
                                <td>{{ apk.descripcion !== '-' ? apk.descripcion : 'SIN DESCRIPCIÓN' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Paginación -->
                <nav v-if="totalPages > 1">
                    <ul class="pagination justify-content-center">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <button class="page-link" @click="currentPage = 1">&laquo;</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <button class="page-link" @click="prevPage">&lsaquo;</button>
                        </li>
                        <li class="page-item" v-for="page in totalPages" :key="page"
                            :class="{ active: currentPage === page }">
                            <button class="page-link" @click="currentPage = page">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <button class="page-link" @click="nextPage">&rsaquo;</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <button class="page-link" @click="currentPage = totalPages">&raquo;</button>
                        </li>
                    </ul>
                </nav>
            </div>
            <!-- Bloque Conversiones y OEMs -->
            <div id="conversionesproductos" class="w-100 mb-4"
                v-if="filteredConversions.length > 0 || filteredOems.length > 0"
                v-tooltip.top="`Sección para ver códigos alternos y originales`">

                <h4>
                    <i class="bx bx-globe" style="font-size: 1.5rem;"></i>
                    &nbsp;Equivalencias
                </h4>

                <div class="row w-100 mx-0">
                    <!-- Conversiones -->
                    <div :class="detailsprods.conversiones.length > 0 && detailsprods.oems.length > 0 ? 'col-md-6 px-2' : 'col-12 px-2'"
                        v-if="detailsprods.conversiones.length > 0">

                        <h5 class="text-center mb-3">
                            <i class="bx bx-transfer"></i> Conversiones
                        </h5>

                        <div class="table-responsive">
                            <table class="table table-striped table-bordered text-center align-middle">
                                <thead class="table-light">
                                    <tr>
                                        <th>Competencia</th>
                                        <th>Código</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(conv, i) in paginatedConversions" :key="'conv-' + i">
                                        <td>{{ conv.competencia }}</td>
                                        <td>{{ conv.codigo }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Paginación Conversiones -->
                        <nav v-if="totalPagesConv > 1">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" :class="{ disabled: currentPageConv === 1 }">
                                    <button class="page-link" @click="currentPageConv = 1">&laquo;</button>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPageConv === 1 }">
                                    <button class="page-link" @click="currentPageConv--">&lsaquo;</button>
                                </li>
                                <li class="page-item" v-for="page in totalPagesConv" :key="'pconv-' + page"
                                    :class="{ active: currentPageConv === page }">
                                    <button class="page-link" @click="currentPageConv = page">{{ page }}</button>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPageConv === totalPagesConv }">
                                    <button class="page-link" @click="currentPageConv++">&rsaquo;</button>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPageConv === totalPagesConv }">
                                    <button class="page-link" @click="currentPageConv = totalPagesConv">&raquo;</button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <!-- OEMs -->
                    <div :class="detailsprods.conversiones.length > 0 && detailsprods.oems.length > 0 ? 'col-md-6 px-2' : 'col-12 px-2'"
                        v-if="detailsprods.oems.length > 0">

                        <h5 class="text-center mb-3">
                            <i class="bx bx-buildings"></i> OEM / Ensambladoras
                        </h5>

                        <div class="table-responsive">
                            <table class="table table-striped table-bordered text-center align-middle">
                                <thead class="table-light">
                                    <tr>
                                        <th>Ensambladora</th>
                                        <th>Código</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(oem, i) in paginatedOems" :key="'oem-' + i">
                                        <td>{{ oem.marca }}</td>
                                        <td>{{ oem.codigo }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Paginación OEMs -->
                        <nav v-if="totalPagesOem > 1">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" :class="{ disabled: currentPageOem === 1 }">
                                    <button class="page-link" @click="currentPageOem = 1">&laquo;</button>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPageOem === 1 }">
                                    <button class="page-link" @click="currentPageOem--">&lsaquo;</button>
                                </li>
                                <li class="page-item" v-for="page in totalPagesOem" :key="'poem-' + page"
                                    :class="{ active: currentPageOem === page }">
                                    <button class="page-link" @click="currentPageOem = page">{{ page }}</button>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPageOem === totalPagesOem }">
                                    <button class="page-link" @click="currentPageOem++">&rsaquo;</button>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPageOem === totalPagesOem }">
                                    <button class="page-link" @click="currentPageOem = totalPagesOem">&raquo;</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
        </div>


        <div id="ventas" class="align-items-center w-100 mb-3">
            <h4 class="fw-bold mb-3">
                <i class="bx bxs-bulb"></i>&nbsp;Recomendaciones
            </h4>
            <div class="row w-100">
                <sugerencias :ProductoVer="claveprod"></sugerencias>
            </div>
        </div>


        <div class="secciones" id="relacionados" v-if="detailsprods.relacionados.length > 0">
            <section class="seccion">
                <div class="grupo">
                    <i class="bx bx-sitemap" style="font-size:24px;color:#ff9900;"></i>&nbsp;
                    <h3 class="h3prod">Productos Relacionados</h3>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 mb-4" v-for="producto in detailsprods.relacionados"
                        :key="producto.id">
                        <!-- Aquí colocas el contenido de cada producto -->
                        <div class="card"
                            style="width: 10rem; border: none !important; box-shadow: none !important; overflow: hidden;">
                            <img v-if="producto.PicturesUrl[4]" v-bind:src="producto.PicturesUrl[4].sm"
                                alt="Imagen de producto" class="card-image" loading="lazy">
                            <img v-else :src="getAbsoluteImageUrl('/img/display/Placeholder.png')"
                                alt="Imagen de producto por defecto" class="card-image" loading="lazy">
                            <div class="card-content">
                                <h3 class="card-title">
                                    <router-link :to="{ name: 'verprods', params: { id: producto.k_parte } }"
                                        style="font-size:12px;border: none;color:#06283c; text-decoration: none;">
                                        {{ producto.k_parte }}
                                    </router-link>
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </div>
        <h4 class="fw-bold mb-3">🔗 Productos Relacionados</h4>
        <div class="container">
            <!-- Título general -->
            <div class="row">
                <!-- Columna izquierda: Lista de productos -->
                <div class="col-md-4 border-end overflow-auto" style="max-height: 80vh;">
                    <div class="row g-2 p-2">
                        <div class="col-6" v-for="producto in productosCompatibles" :key="producto.id">
                            <div class="card h-100 cursor-pointer shadow-sm"
                                :class="producto.id === productoSeleccionadocompatible?.id ? 'border border-primary' : 'border-0'"
                                @click="seleccionarProducto(producto)"
                                style="transition: transform 0.3s, box-shadow 0.3s;"
                                v-tooltip.top="`Click aquí para ver más detalles de ${producto.k_parte}`"
                                data-bs-toggle="tooltip" data-bs-placement="top">
                                <!-- Imagen dinámica con fallback -->
                                <div v-if="producto.PicturesUrl[
                                    producto.categorias &&
                                        producto.categorias.length &&
                                        producto.categorias[0].marcas.viewimagesprinc
                                        ? producto.categorias[0].marcas.viewimagesprinc
                                        : 4
                                ]">
                                    <img :src="producto.PicturesUrl[
                                        producto.categorias &&
                                            producto.categorias.length &&
                                            producto.categorias[0].marcas.viewimagesprinc
                                            ? producto.categorias[0].marcas.viewimagesprinc
                                            : 4
                                    ].sm" alt="Imagen del producto" class="card-img-top" loading="lazy"
                                        style="height: 100px; object-fit: contain;" />
                                </div>
                                <div v-else>
                                    <img src="/img/display/Placeholder.png" alt="Imagen no disponible" loading="lazy"
                                        class="card-img-top" style="height: 100px; object-fit: contain;" />
                                </div>

                                <!-- Contenido de la card -->
                                <div class="card-body p-2 text-center">
                                    <div>
                                        <h6 class="mb-1 fw-bold">{{ producto.k_parte }}</h6>
                                        <div class="text-muted small">{{ producto.linea }}</div>

                                        <p class="card-text small text-muted mb-0">
                                            {{ producto.descripcion?.substring(0, 50) }}...
                                        </p>
                                        <div v-if="producto.id === productoSeleccionadocompatible?.id"
                                            class="text-primary small">
                                            Viendo detalles</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Columna derecha: Detalle del producto seleccionado -->
                <div class="col-md-8">
                    <div v-if="productoSeleccionadocompatible" class="p-3">

                        <div v-if="productoSeleccionadocompatible.PicturesUrl[
                            productoSeleccionadocompatible.categorias &&
                                productoSeleccionadocompatible.categorias.length &&
                                productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                ? productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                : 4
                        ]">
                            <img :src="productoSeleccionadocompatible.PicturesUrl[
                                productoSeleccionadocompatible.categorias &&
                                    productoSeleccionadocompatible.categorias.length &&
                                    productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                    ? productoSeleccionadocompatible.categorias[0].marcas.viewimagesprinc
                                    : 4
                            ].sm" alt="Imagen del producto" class="mb-3 d-block mx-auto rounded border" loading="lazy"
                                style="height: 250px; object-fit: contain;" />
                        </div>
                        <div v-else>
                            <img src="/img/display/Placeholder.png" alt="Imagen no disponible" loading="lazy"
                                class="mb-3 d-block mx-auto rounded border"
                                style="height: 250px; object-fit: contain;" />
                        </div>
                        <h3 class="mb-2">{{ productoSeleccionadocompatible.k_parte }}</h3>
                        <p>{{ productoSeleccionadocompatible.linea }}</p>
                        <p>{{ productoSeleccionadocompatible.descripcion }}</p>

                        <h5 class="mt-4">Aplicaciones compatibles:</h5>
                        <div class="border rounded p-2 mt-2" style="max-height: 25vh; overflow-y: auto;">
                            <ul class="mb-0">
                                <li v-for="app in productoSeleccionadocompatible.aplicaciones" :key="app.id"
                                    class="small">
                                    <span v-if="app.posicion && app.posicion !== '-'"><strong>{{ app.posicion
                                            }}</strong> - </span>
                                    <span v-if="app.traccion && app.traccion !== '-'"><strong>{{ app.traccion
                                            }}</strong> - </span>
                                    <span v-if="app.transmision && app.transmision !== '-'"><strong>{{
                                        app.transmision
                                            }}</strong> -
                                    </span>
                                    <span v-if="app.litros && app.litros !== '-'"><strong>{{ app.litros }}</strong>
                                        -
                                    </span>
                                    <span v-if="app.cilindros && app.cilindros !== '-'"><strong>{{ app.cilindros
                                            }}</strong> -
                                    </span>
                                    <span v-if="app.combustible && app.combustible !== '-'"><strong>{{
                                        app.combustible
                                            }}</strong> -
                                    </span>
                                    {{ app.marca }} - {{ app.modelo }} ({{ app.year }})
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-else class="p-3 text-muted">
                        <!-- Imagen de la marca si existe categoría y marca -->
                        <div
                            v-if="detailsprods.categorias && detailsprods.categorias.length && detailsprods.categorias[0].marcas">
                            <img :src="getAbsoluteImageUrl('/img/marcas/' + detailsprods.categorias[0].marcas.name + '.webp')"
                                alt="Marca" class="mb-3 d-block mx-auto rounded border"
                                style="height: 80px; object-fit: contain;" loading="lazy" />
                        </div>

                        <!-- Fallback si no hay categorías o marca -->
                        <div v-else class="text-muted text-center my-3">
                            <em>Selecciona un producto de la izquierda para ver más detalles</em>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <!-- modal para dar clic a la imagen y hacer zoom -->
    <div class="modal fade" id="modalZoomVistaProd" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true" @hidden="closeModal">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="image-container" style="position: relative; overflow: hidden;">
                        <img :src="modalImage" alt="Image" class="modal-image" ref="zoomImage" @mousemove="zoomImage"
                            @mouseleave="resetZoom" loading="lazy" />
                        <div v-if="showLens" class="zoom-lens" :style="lensStyle"></div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="zoom-controls d-flex justify-content-center gap-2 mb-3">
                        <button @click="zoomOut" class="btn btn-secondary" type="button">-</button>
                        <button @click="zoomIn" class="btn btn-secondary" type="button">+</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--Modal 360°-->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        IMAGEN 360°
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div v-if="img360view.length > 1">
                        <view360 :ProductoVerSlider="img360view"></view360>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Modal para reporte de detalle con el producto-->
    <div class="modal fade" id="reporteProducto" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Reporte Producto</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitFormReporProds">
                        <div class="mb-3">
                            <label for="asunto" class="form-label">Asunto</label>
                            <select class="form-select" id="asunto" v-model="reporte.asunto">
                                <option v-for="opcion in opcionesAsunto" :key="opcion.valor" :value="opcion.valor">{{
                                    opcion.texto }}</option>
                                <!--<option v-if="usuarioAutenticado" value="opcionPersonalizada">Opción Personalizada</option>-->
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="nombre" class="form-label">Nombre</label>
                            <input type="text" class="form-control" id="nombre" v-model="reporte.nombre"
                                style="text-transform: uppercase;">
                        </div>
                        <div class="mb-3">
                            <label for="apellido" class="form-label">Apellido</label>
                            <input type="text" class="form-control" id="apellido" v-model="reporte.apellido"
                                style="text-transform: uppercase;">
                        </div>
                        <div class="mb-3">
                            <label for="correo" class="form-label">Correo</label>
                            <input type="email" class="form-control" id="correo" v-model="reporte.correo">
                        </div>
                        <div class="mb-3">
                            <label for="telefono" class="form-label">Teléfono</label>
                            <input type="text" class="form-control" id="telefono" v-model="reporte.telefono"
                                pattern="[0-9]*" maxlength="10">
                        </div>
                        <div class="mb-3">
                            <label for="detalle" class="form-label">Detalle</label>
                            <textarea class="form-control" id="detalle" rows="3" v-model="reporte.detalle"
                                style="text-transform: uppercase;"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary">Enviar</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!--Modal galeria de imagenes-->
    <div class="modal fade modal-galeria" id="modalVerTodasImagenes" tabindex="-1"
        aria-labelledby="modalVerTodasImagenes" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl modal-galeria-dialog">
            <div class="modal-content modal-galeria-content">
                <div class="modal-header modal-galeria-header">
                    <h5 class="modal-title">Galería de Imágenes</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body p-0 modal-galeria-body">
                    <div class="container-fluid d-flex flex-column align-items-center modal-galeria-container">
                        <!-- Imagen principal -->
                        <div class="d-flex align-items-center justify-content-center bg-light p-2 w-100 modal-galeria-principal"
                            style="height: 60vh; max-height: 600px;">
                            <img :src="detailsprods.PicturesUrl?.[imagenSeleccionadaModal]?.sm || getAbsoluteImageUrl('/img/display/Placeholder.png')"
                                loading="lazy" class="img-fluid modal-galeria-img"
                                style="max-height: 100%; max-width: 100%; object-fit: contain;" />
                        </div>

                        <!-- Miniaturas abajo con scroll horizontal -->
                        <div class="d-flex align-items-center justify-content-start p-2 mt-2 w-100 modal-galeria-miniaturas"
                            style="overflow-x: auto; overflow-y: hidden; height: 100px;">
                            <ul class="list-unstyled d-flex flex-row gap-2 mb-0">
                                <li v-for="(img, key) in detailsprods.PicturesUrl" :key="key"
                                    class="miniatura-item-galeria" @click="imagenSeleccionadaModal = key">
                                    <div class="border rounded"
                                        :class="{ 'border-primary': imagenSeleccionadaModal === key }"
                                        style="width: 80px; height: 80px; overflow: hidden; cursor: pointer;">
                                        <img :src="img.sm" style="width: 100%; height: 100%; object-fit: cover;"
                                            loading="lazy" />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    <script>
    import { defineAsyncComponent } from 'vue'
    export default {
        components: {
            car: defineAsyncComponent(() => import(/* webpackChunkName: "carShop2V041020252051" */'./carShop2.vue')),
            sugerencias: defineAsyncComponent(() => import(/* webpackChunkName: "SeccionProdsDestacarVistaProductos2V011020251200" */'../navegation/ComponentsRecomend/CompoentsViews/SeccionProdsDestacarVistaProductos2.vue')),
            viewsProdsVariante: defineAsyncComponent(() => import(/* webpackChunkName: "productosviewVariantesV011020251200" */'../navegation/ComponentsRecomend/CompoentsViews/productosviewVariantes.vue')),
            view360: defineAsyncComponent(() => import(/* webpackChunkName: "360V011020251200" */'../navegation/ComponentsRecomend/Sliders/360.vue')),
            Badges: defineAsyncComponent(() => import(/* webpackChunkName: "BadgesV011020251200" */'../navegation/ComponentsRecomend/Sliders/Badges.vue')),
        },
        data() {
            return {
                loading: true,
                scrolled: false,
                showviewcart: window.Laravel.compras,
                viewprecios: window.Laravel.verprecios,
                isLoggedin: window.Laravel.isLoggedin,
                claveprod: '',
                imagenposicion: 4,
                aplicacionselect: {},
                currentImageIndex: 0,
                isPlaying: false,
                playInterval: null,
                detailsprods: [],
                detailsaplicaciones: {},
                activeItem: null,
                filtro: '',
                aplicacionesfiltro: '',
                oems: {},
                scrolled: false,
                reporte: {
                    asunto: '',
                    nombre: '',
                    apellido: '',
                    correo: '',
                    telefono: '',
                    detalle: '',
                    parte: '',
                    linea: ''
                },
                opcionesAsunto: [
                    { valor: 'FOTONOCORRESPONDE', texto: 'Foto no corresponde al producto' },
                    { valor: 'FOTONOSEAPRECIA', texto: 'Foto no se aprecia correctamente' },
                    { valor: 'CONVERSIONES', texto: 'Error en lista de conversiones' },
                    { valor: 'APLICACIONES', texto: 'Error en lista compatibilidad / aplicaciones' },
                    { valor: 'INFORMACION', texto: 'Error en información / incompleta' },
                    //{ valor: 'INFORMACION', texto: 'Error en información / incompleta' },
                    // Agrega más opciones aquí
                ],
                masproductoscart: [],
                prodscomplement: [],
                tendencias: [],
                img360view: [],
                showModal: false,
                modalImage: '',
                showModal: false,
                showLens: false,
                lensStyle: { left: '0px', top: '0px' },
                zoomFactor: 1,       // zoom inicial 1 (sin zoom)
                minZoom: 1,
                maxZoom: 5,
                urlshare: window.location.href,  // Usa la URL actual de la página
                titleshare: 'Cecra',
                textshare: 'Producto a Recomendar',
                isShareSupported: false,
                estadoproducto: 1,
                imagenSeleccionadaModal: null,
                productosCompatibles: [],
                productoSeleccionadocompatible: null,
                currentPage: 1,
                rowsPerPage: 20,
                sortKey: 'year',
                sortAsc: false,
                // Conversiones
                currentPageConv: 1,
                itemsPerPageConv: 10,

                // OEMs
                currentPageOem: 1,
                itemsPerPageOem: 10,
            };
        },


        methods: {
            seleccionarProducto(producto) {
                if (this.productoSeleccionadocompatible?.id === producto.id) {
                    this.productoSeleccionadocompatible = null;
                } else {
                    this.productoSeleccionadocompatible = producto;
                }
            },
            verTodasLasImagenes() {
                if (this.detailsprods && this.detailsprods.PicturesUrl && Object.keys(this.detailsprods.PicturesUrl).length > 0) {
                    const keys = Object.keys(this.detailsprods.PicturesUrl);
                    this.imagenSeleccionadaModal = keys[0];
                } else {
                    this.imagenSeleccionadaModal = null;
                }
                $('#modalVerTodasImagenes').modal('show')
            },
            shareContent() {
                // Comprueba si el navegador soporta la API de compartir
                if (navigator.share) {
                    // Llama a la API de compartir
                    navigator.share({
                        title: this.titleshare,  // Título que aparece al compartir
                        text: this.textshare,    // Texto que acompaña al enlace
                        url: this.urlshare,      // URL que estás compartiendo
                    })
                        .then(() => {
                            console.log('Contenido compartido exitosamente');
                        })
                        .catch((error) => {
                            console.error('Error al compartir:', error);
                        });
                } else {
                    // En caso de que el navegador no soporte la API de compartir
                    alert('La función de compartir no es compatible con tu navegador');
                }
            },
            scrollToAplicaciones(param) {
                const element = document.getElementById(param);
                if (element) {
                    // Scroll al inicio del elemento
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });

                    // Opcional: si tienes header fijo y quieres un poco de margen
                    const yOffset = -120; // ajusta según la altura del header
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            },
            openModal(imageUrl) {
                this.modalImage = imageUrl;
                this.showModal = true;
                this.showLens = false;
                this.zoomFactor = 1;
                this.applyZoomCenter();
                $('#modalZoomVistaProd').modal('show');

                this.$nextTick(() => {
                    const img = this.$refs.zoomImage;
                    if (img) {
                        img.addEventListener('wheel', this.handleWheelZoom, { passive: false });
                    }
                });
            },

            handleWheelZoom(event) {
                event.preventDefault(); // evita scroll de página
                if (event.deltaY < 0) {
                    // scroll arriba → zoom in
                    this.zoomIn();
                } else {
                    // scroll abajo → zoom out
                    this.zoomOut();
                }
            },

            closeModal() {
                // remover listener al cerrar
                const img = this.$refs.zoomImage;
                if (img) {
                    img.removeEventListener('wheel', this.handleWheelZoom);
                }
                $('#modalZoomVistaProd').modal('hide');
            },
            zoomImage(event) {
                const lens = this.$refs.zoomImage;
                const lensWidth = 100;
                const lensHeight = 100;

                const { left, top, width, height } = lens.getBoundingClientRect();

                const mouseX = event.clientX - left;
                const mouseY = event.clientY - top;

                if (mouseX < 0 || mouseY < 0 || mouseX > width || mouseY > height) {
                    this.resetZoom();
                    return;
                }

                if (this.zoomFactor <= 1) {
                    // Si no hay zoom no mostrar lente
                    this.showLens = false;
                    lens.style.transform = 'scale(1)';
                    return;
                }

                this.showLens = true;

                this.lensStyle.left = `${mouseX - lensWidth / 2}px`;
                this.lensStyle.top = `${mouseY - lensHeight / 2}px`;

                lens.style.transform = `scale(${this.zoomFactor})`;
                lens.style.transformOrigin = `${(mouseX / width) * 100}% ${(mouseY / height) * 100}%`;
            },

            resetZoom() {
                this.showLens = false;
                const lens = this.$refs.zoomImage;
                lens.style.transform = `scale(${this.zoomFactor})`;
                lens.style.transformOrigin = '50% 50%';
            },

            zoomIn() {
                if (this.zoomFactor < this.maxZoom) {
                    this.zoomFactor = Math.min(this.maxZoom, this.zoomFactor + 0.5);
                    this.showLens = false;  // deshabilita lente en zoom por botón
                    this.applyZoomCenter();
                }
            },

            zoomOut() {
                if (this.zoomFactor > this.minZoom) {
                    this.zoomFactor = Math.max(this.minZoom, this.zoomFactor - 0.5);
                    if (this.zoomFactor === 1) {
                        // reset zoom total cuando llegue a 1
                        this.showLens = false;
                        const lens = this.$refs.zoomImage;
                        lens.style.transform = 'scale(1)';
                        lens.style.transformOrigin = '50% 50%';
                    } else {
                        this.showLens = false;
                        this.applyZoomCenter();
                    }
                }
            },

            applyZoomCenter() {
                const lens = this.$refs.zoomImage;
                if (!lens) return;

                lens.style.transform = `scale(${this.zoomFactor})`;
                lens.style.transformOrigin = `50% 50%`;
            },
            getAbsoluteImageUrl(relativeUrl) {
                // Obtén la URL base de Laravel
                const baseUrl = window.location.origin;

                // Concatena la URL base con la ruta relativa de la imagen
                return baseUrl + relativeUrl;
            },
            handleScroll() {
                const container = this.$el.querySelector('.menu-container');
                // Verificar si el usuario se ha desplazado
                this.scrolled = container.scrollTop > 0;
            },
            formatearPrecio(valor) {
                // Asegurarse de que el valor sea un número
                const numero = Number(valor);

                // Verificar si el número es válido y no es NaN
                if (!isNaN(numero)) {
                    // Formatear el número
                    return numero.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
                } else {
                    // Si no es un número válido, devolver un valor por defecto o un mensaje de error
                    return 'Valor no válido';
                }
            },
            view360(imagenes) {
                this.img360view = imagenes
                $('#exampleModal').modal('show')

            },
            imagenselec(valueimg) {
                this.imagenposicion = valueimg
            },
            primeraImagen(producto) {
                // Tomamos la primera imagen disponible en PicturesUrl
                const keys = Object.keys(producto.PicturesUrl || {});
                if (keys.length) {
                    return producto.PicturesUrl[keys[1]].sm;
                }
                // Si no hay ninguna, se puede devolver un placeholder genérico
                return '/img/display/Placeholder.png';
            },
            formatItem(value) {
                // Reemplazar "/" con "<br>" para los saltos de línea
                if (!value) {
                    return ""; // O manejar el caso en que los datos no son válidos
                }
                const formattedText = value.replace(/\/\s*/g, '</span><br><span>');
                const boldText = `<span>${formattedText}</span>`;
                return boldText;
            },
            togglePlay() {
                this.isPlaying = !this.isPlaying;

                if (this.isPlaying) {
                    // Iniciar reproducción automática
                    this.playInterval = setInterval(() => {
                        // Avanzar a la siguiente imagen
                        this.currentImageIndex = (this.currentImageIndex + 1) % this.smImages.length;

                        // Verificar si se ha alcanzado la última imagen
                        if (this.currentImageIndex === 0) {
                            // Detener reproducción cuando se alcanza la última imagen
                            this.isPlaying = false;
                            clearInterval(this.playInterval);
                        }
                    }, 100); // Ajusta el intervalo según tu preferencia
                } else {
                    // Detener reproducción
                    clearInterval(this.playInterval);
                }
            },
            rotateLeft() {
                // Lógica para rotar la imagen a la izquierda
                // Puedes, por ejemplo, decrementar el índice actual o realizar operaciones de rotación en la imagen si estás manejando la rotación del contenido de la imagen.
                // Actualizar currentImageIndex
                this.currentImageIndex = (this.currentImageIndex - 1 + this.smImages.length) % this.smImages.length;
            },

            rotateRight() {
                // Lógica para rotar la imagen a la derecha
                // Puedes, por ejemplo, incrementar el índice actual o realizar operaciones de rotación en la imagen si estás manejando la rotación del contenido de la imagen.
                // Actualizar currentImageIndex
                this.currentImageIndex = (this.currentImageIndex + 1) % this.smImages.length;
            },
            scrollToSummary() {
                const summarySection = document.getElementById('info');
                if (summarySection) {
                    summarySection.scrollIntoView({ behavior: 'smooth' });
                }
            },
            // Método para desplazar la página a la sección de Compatibilidad
            scrollToCompatibility() {
                const compatibilitySection = document.getElementById('compatible');
                if (compatibilitySection) {
                    compatibilitySection.scrollIntoView({ behavior: 'smooth' });
                }
            },
            // Método para desplazar la página a la sección de Conversiones
            scrollToConversions() {
                const conversionsSection = document.getElementById('conversion');
                if (conversionsSection) {
                    conversionsSection.scrollIntoView({ behavior: 'smooth' });
                }
            },
            // Método para desplazar la página a la sección de Productos Relacionados
            scrollToRelatedProducts() {
                const relatedProductsSection = document.getElementById('relacionados');
                if (relatedProductsSection) {
                    relatedProductsSection.scrollIntoView({ behavior: 'smooth' });
                }
            },
            // Método para desplazar la página a la sección de Compartir
            scrollToShare() {
                const shareSection = document.getElementById('hc');
                if (shareSection) {
                    shareSection.scrollIntoView({ behavior: 'smooth' });
                }
            },
            changeImage(direction) {
                this.currentImageIndex = (this.currentImageIndex + direction + this.smImages.length) % this.smImages.length;
            },
            submitFormReporProds() {
                this.reporte.parte = this.detailsprods[0].k_parte;
                this.reporte.linea = this.detailsprods[0].linea;
                axios.post('/api/App/crearRepoProd', this.reporte)
                    .then(response => {
                        // Muestra una alerta de éxito utilizando SweetAlert
                        this.reporte = {
                            asunto: '',
                            nombre: '',
                            apellido: '',
                            correo: '',
                            telefono: '',
                            detalle: '',
                            parte: '',
                            linea: ''
                        },
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'El formulario se ha enviado correctamente.',
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'OK',
                                timer: 2000, // La alerta se cerrará automáticamente después de 2 segundos
                                timerProgressBar: true
                            });
                    })
                    .catch(error => {
                        // Muestra una alerta de error utilizando SweetAlert
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Ha ocurrido un error al enviar el formulario.',
                            confirmButtonColor: '#d33',
                            confirmButtonText: 'OK',
                            timer: 2000, // La alerta se cerrará automáticamente después de 2 segundos
                            timerProgressBar: true

                        });
                        console.error('Error al enviar el formulario:', error);
                    });
            },
            detailsprodsViews() {
                axios.get('/searchDetails/details', {
                    params: {
                        claveprod: this.claveprod,
                        operacion: 1,
                    }
                }).then((response) => {

                    const isLoggedin = !response.data.loggin ? false : true;
                    this.$store.dispatch('updateLoginStatus', isLoggedin);

                    // También puedes actualizar window.Laravel si necesitas hacerlo globalmente
                    window.Laravel.isLoggedin = isLoggedin;
                    if (response.data.existeprods === 0 || response.data.existeprods === 2) {
                        this.estadoproducto = response.data.existeprods
                        this.loading = false
                        return;
                    }
                    this.detailsprods = response.data.results

                    if (this.detailsprods &&
                        this.detailsprods.categorias[0] &&
                        this.detailsprods.categorias[0].marcas &&
                        this.detailsprods.categorias[0].marcas.viewimagesgde !== null) {
                        // La propiedad viewimagesprinc no es null
                        this.imagenposicion = this.detailsprods.categorias[0].marcas.viewimagesgde
                    }
                    this.loading = false;
                }).catch((error) => {
                    if (error.response && error.response.status === 429) {
                        const isLoggedin = false;

                        // Mostrar alerta de sesión expirada
                        Swal.fire({
                            title: 'Límite Excedido',
                            text: 'El limite de consultas se excedio. Por favor, ingresa como usuario.',
                            icon: 'warning',
                            confirmButtonText: 'Aceptar',
                        }).then(() => {
                            // Redirigir a la página de inicio de sesión
                            window.location.href = `${window.location.origin}/Ingresa`;
                        });
                    } else {
                        console.log(error);
                    }
                });

            },
            handleScroll() {
                // Verifica si la posición de desplazamiento es mayor que 0
                this.scrolled = window.scrollY > 0;
            },
            copyLink() {
                navigator.clipboard.writeText(this.urlshare).then(() => {
                    alert('Enlace copiado al portapapeles');
                }, (err) => {
                    console.error('Error al copiar el enlace:', err);
                });
            },
            async fetchProductosCompatibles() {
                try {
                    const response = await axios.post('/searchDetails/productoscompatibles', {
                        producto_id: this.claveprod
                    });
                    this.productosCompatibles = response.data;
                } catch (error) {
                    console.error('Error al obtener productos compatibles:', error);
                }
            },
            sortBy(column) {
                if (this.sortKey === column) {
                    this.sortAsc = !this.sortAsc;
                } else {
                    this.sortKey = column;
                    this.sortAsc = true;
                }

                this.detailsprods.aplicaciones.sort((a, b) => {
                    let valA = a[column];
                    let valB = b[column];

                    if (column === 'year') {
                        valA = parseInt(valA.split('-')[0]);
                        valB = parseInt(valB.split('-')[0]);
                    }
                    else if (column === 'motor') {
                        const parseLitros = (apk) => {
                            if (!apk || apk.litros === '-' || apk.litros == null) return NaN;
                            let s = String(apk.litros).trim().replace(',', '.');
                            s = s.endsWith('L') ? s.slice(0, -1) : s; // quitar la "L" si existe
                            return parseFloat(s) || NaN;
                        };

                        let numA = parseLitros(a);
                        let numB = parseLitros(b);

                        if (!isFinite(numA)) numA = this.sortAsc ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
                        if (!isFinite(numB)) numB = this.sortAsc ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;

                        return this.sortAsc ? numA - numB : numB - numA;
                    }
                    if (valA < valB) return this.sortAsc ? -1 : 1;
                    if (valA > valB) return this.sortAsc ? 1 : -1;
                    return 0;
                });
            },
            prevPage() {
                if (this.currentPage > 1) this.currentPage--;
            },
            nextPage() {
                if (this.currentPage < this.totalPages) this.currentPage++;
            }
            ////saca los productos de los carritos que se han vendido junto con el producto que estes viendo

        },
        beforeDestroy() {
        },
        mounted() {
            if (this.$route.params.id) {
                this.claveprod = this.$route.params.id;
                this.detailsprodsViews(); // Llama manualmente al método si es necesario
                this.fetchProductosCompatibles();
            }
        },
        computed: {
            totalPages() {
                return Math.ceil(this.sortedData.length / this.rowsPerPage);
            },
            sortedData() {
                return this.detailsprods.aplicaciones.sort((a, b) => {
                    if (this.sortKey === 'year') {
                        return this.sortAsc ? a.year - b.year : b.year - a.year;
                    } else {
                        const valA = a[this.sortKey] ? a[this.sortKey].toString().toLowerCase() : '';
                        const valB = b[this.sortKey] ? b[this.sortKey].toString().toLowerCase() : '';
                        if (valA < valB) return this.sortAsc ? -1 : 1;
                        if (valA > valB) return this.sortAsc ? 1 : -1;
                        return 0;
                    }
                });
            },
            paginatedData() {
                const start = (this.currentPage - 1) * this.rowsPerPage;
                return this.sortedData.slice(start, start + this.rowsPerPage);
            },
            totalPages() {
                return Math.ceil(this.detailsprods.aplicaciones.length / this.rowsPerPage);
            },
            facebookShareUrl() {
                return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.urlshare)}`;
            },
            twitterShareUrl() {
                return `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.urlshare)}&text=${encodeURIComponent(this.textshare)}`;
            },
            whatsappShareUrl() {
                return `https://api.whatsapp.com/send?text=${encodeURIComponent(this.textshare + ' ' + this.urlshare)}`;
            },
            menuStyle() {
                return {
                    top: this.scrolled ? '10%' : '18%' // Cambiar el valor de top según sea necesario
                };
            },
            filteredConversions() {
                // Si no hay ningún detalle de productos, devolvemos un array vacío
                if (!this.detailsprods || this.detailsprods.length === 0) {
                    return [];
                }
                // Filtramos las conversiones según el texto ingresado en el campo de búsqueda
                return this.detailsprods.conversiones.filter(conversion =>
                    conversion.competencia.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    conversion.codigo.toLowerCase().includes(this.filtro.toLowerCase())
                );
            },
            filteredOems() {

                // Si no hay ningún detalle de productos, devolvemos un array vacío
                if (!this.detailsprods.oems || Object.entries(this.detailsprods.oems).length === 0) {
                    return [];
                }
                // Filtramos las conversiones según el texto ingresado en el campo de búsqueda
                return this.detailsprods.oems.filter(oem =>
                    oem.marca.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    oem.codigo.toLowerCase().includes(this.filtro.toLowerCase())
                );
            },
            smImages() {
                if (this.detailsprods && Array.isArray(this.detailsprods) && this.detailsprods.length > 0) {
                    const firstProduct = this.detailsprods;
                    if (firstProduct && Array.isArray(firstProduct.PicturesUrl)) {
                        return firstProduct.PicturesUrl.filter(function (image) {
                            return image.sm;
                        });
                    }
                }
                return [];
            },

            currentImageUrl() {
                return this.smImages[this.currentImageIndex] ? this.smImages[this.currentImageIndex].sm : '';
            },
            isLoggedin() {

                return this.$store.getters.isLoggedin
            },
            actualizarEstadoListaFavoritos(nuevoEstado) {
                this.detailsprods.en_lista_favoritos = nuevoEstado;
            },
            // Conversiones
            totalPagesConv() {
                return Math.ceil(this.detailsprods.conversiones.length / this.itemsPerPageConv);
            },
            paginatedConversions() {
                const start = (this.currentPageConv - 1) * this.itemsPerPageConv;
                return this.detailsprods.conversiones.slice(start, start + this.itemsPerPageConv);
            },

            // OEMs
            totalPagesOem() {
                return Math.ceil(this.detailsprods.oems.length / this.itemsPerPageOem);
            },
            paginatedOems() {
                const start = (this.currentPageOem - 1) * this.itemsPerPageOem;
                return this.detailsprods.oems.slice(start, start + this.itemsPerPageOem);
            }
        },
        watch: {
            '$route.params.id': {
                handler(newVal) {
                    if (!newVal) {
                        //console.log('El valor de $route.params.id es vacío');
                        return; // Si el valor es vacío, no hacer nada
                    }
                    this.loading = true
                    this.claveprod = newVal;
                    this.detailsprodsViews();
                    this.fetchProductosCompatibles();
                    this.key += 1; // Incrementar la clave para forzar un nuevo renderizado
                },
                deep: true
            }
        },

    };
</script>